/**
 * Releases focus inside the embedded viewer before asking the parent SDK to
 * remove the iframe. Browser password-manager UI is native chrome, so it must
 * observe the focus change before the field disappears.
 */
export function requestSdkClose(): void {
  const { activeElement } = document;
  if (activeElement instanceof HTMLElement) {
    activeElement.blur();
  }

  const targetOrigin = new URLSearchParams(window.location.search).get('parentOrigin') || '*';
  const postCloseMessage = () => {
    window.parent.postMessage({ type: 'CLOSE_MODAL' }, targetOrigin);
  };

  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(postCloseMessage);
    return;
  }

  window.setTimeout(postCloseMessage, 0);
}

/** Asks the embedding SDK to navigate the parent page to an HTTPS destination. */
export function requestSdkExternalRedirect(url: string, reason?: string): void {
  const targetOrigin = new URLSearchParams(window.location.search).get('parentOrigin') || '*';
  window.parent.postMessage(
    { type: 'EXTERNAL_REDIRECT', payload: { url, ...(reason ? { reason } : {}) } },
    targetOrigin,
  );
}

/** Accept only a same-origin handoff endpoint; never hand its code to the parent page. */
export function paymentHandoffDestination(url: string): URL {
  const destination = new URL(url);
  if (
    destination.origin !== window.location.origin ||
    !/^\/api\/v1\/viewer\/payment-handoff\/[A-Za-z0-9_-]{43}$/.test(destination.pathname) ||
    destination.search ||
    destination.hash
  ) {
    throw new Error('Invalid payment handoff destination.');
  }
  return destination;
}

export function requestSdkPaymentHandoffRedirect(url: string): void {
  window.top?.location.replace(paymentHandoffDestination(url).href);
}
